<template>
  <div class="charge">
    <div class="color-black">
      <el-button type="text" @click="$router.go(-1)" class="pr-5 el-icon-d-arrow-left"></el-button>
      保证金充值
    </div>
    <div class="mt-20 p-30 pt-40 wall">
      <el-form ref="form" :model="form" label-width="120px" class="charge-form">
        <el-form-item label="">
          <el-alert title="为了保证您的正常销售，您的保证金余额不得低于2000元" type="warning" :closable="false"></el-alert>
        </el-form-item>
        <el-form-item label="当前保证金余额">
          <div class="color-lightGray">
            ¥<span class="ml-5 fs-18">{{$store.getters.userInfo.guarantee_balance || 0}}</span>
          </div>
        </el-form-item>
        <el-form-item label="充值金额" v-if="actionModal == 'edit'" :error="amountError">
          <el-input v-model="form.amount" placeholder="最低充值金额 2000 元">
            <i slot="prefix" class="rs-iconfont rs-icon-renminbi"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="充值金额" v-else class="mt-50">
          <div class="flex">
            <div class="color-lightGray mr-10">
              ¥<span class="ml-5 fs-18">{{form.amount}}</span>
            </div>
            <el-button type="text" @click="actionModal = 'edit'">
              修改
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="" v-if="actionModal == 'edit'" class="mt-50">
          <el-checkbox v-model="readAgree">阅读并同意</el-checkbox>
          <a
            href="https://fulishe-static.oss-cn-zhangjiakou.aliyuncs.com/static/docs/%E7%BA%A2%E8%A2%9C%E5%AD%90%E4%B8%9A%E5%8A%A1%E4%BF%9D%E8%AF%81%E9%87%91%E7%AE%A1%E7%90%86%E8%A7%84%E5%AE%9A.pdf"
            target="_blank"
          >《红袜子业务保证金管理规定》</a>
        </el-form-item>
        <el-form-item label="" v-if="actionModal == 'edit'">
          <el-button type="primary" :disabled="!readAgree" class="main-btn" round @click="handleSubmitAmount">充 值</el-button>
        </el-form-item>
        <el-form-item v-if="actionModal == 'pay'">
          <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
              <el-tab-pane name="wechat">
                <span slot="label"><i class="rs-iconfont rs-icon-weixinzhifu"></i> 微信支付</span>
                <div class="charge-action-box">
                  <img :src="wechatImg" class="wechat-pay-img"/>
                  <span class="color-lightGray">打开微信扫一扫支付</span>
                </div>
              </el-tab-pane>
              <el-tab-pane name="bank" disabled>
                <span slot="label"><i class="rs-iconfont rs-icon-wangyinzhifu"></i> 网银支付</span>
                <div class="charge-action-box">
                  <el-button type="warning" disabled>
                    <i class="rs-iconfont rs-icon-wangyinzhifu"></i>
                    打开网银付款
                  </el-button>
                </div>
              </el-tab-pane>
              <el-tab-pane name="third">
                <span slot="label"><i class="rs-iconfont rs-icon-xianxiadakuan"></i> 线下付款</span>
                <div class="charge-action-box" style="align-items: flex-start">
                  <div class="color-primary ml-10">收款信息</div>
                  <el-form-item label="公司" label-width="80px">
                    <span>深圳市红袜子网络科技有限公司</span>
                  </el-form-item>
                  <el-form-item label="开户行" label-width="80px">
                    <span>招商银行股份有限公司深圳云城支行</span>
                  </el-form-item>
                  <el-form-item label="账号" label-width="80px">
                    <span>755951333310802</span>
                  </el-form-item>
                  <!-- <el-form-item label="税号" label-width="80px">
                    <span></span>
                  </el-form-item>
                  <el-form-item label="电话" label-width="80px">
                    <span></span>
                  </el-form-item> -->
                  <div style="margin: 40px auto;">
                    <el-button type="primary" class="main-btn" round @click="handleOffline">
                      确 认
                    </el-button>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { requestPay, getGuarantees } from '@/api/pay.js';
import QRCode from 'qrcode'
export default {
  data() {
    return {
      activeName: 'wechat',
      actionModal: 'edit',
      wechatImg: null,
      readAgree: false,
      form: {
        amount: 2000
      },
      amountError: null,
      timer: null
    }
  },
  created() {
    // QRCode.toDataURL('I am a pony!', { errorCorrectionLevel: 'H', margin: 2 })
    //   .then(url => {
    //     this.wechatImg = url;
    //   })
    //   .catch(err => {
    //     console.error(err)
    //   });
  },
  methods: {
    handleSubmitAmount() {
      if (this.form.amount < 1) {
        this.amountError = '请输入正确的充值金额';
        return false;
      }
      this.actionModal = 'pay';
      requestPay(this.form.amount).then(res => {
        QRCode.toDataURL(res.code_url, { errorCorrectionLevel: 'H', margin: 2 })
          .then(url => {
            this.wechatImg = url;
          })
          .catch(err => {
            console.error(err)
        });

        let id = res.recharge_id
        let _this = this
        this.timer = setInterval(function() {
          getGuarantees(id).then(res2 => {
            if(res2.status == 'paid'){
              _this.$alert('请前往您的账户进行查看','充值成功',{
                confirmButtonText:'确定',
                callback: () => {
                  _this.$router.go(-1)
                }
              })
              clearInterval(_this.timer)
            }
          })
        }, 2000)
      })
    },
    handleOffline() {
      this.$alert('打款后资金将于48小时内到账，如有问题请及时与您的客服经理取得联系。', '提示', {
        confirmButtonText: '确定',
        callback: () => {
          this.$router.go(-1)
        }
      });
    },
    handleTabClick() {}
  },
  destroyed() {
    clearInterval(this.timer);
  }
}
</script>

<style lang="scss" scoped>
.charge-form {
  width: 500px;
  ::v-deep .el-tabs__item {
    padding: 0 24px;
  }
  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }
  .charge-action-box {
    width: 378px;
    height: 370px;
    border: 1px solid #f0f0f0;
    border-top: none;
    border-radius: 0 0 10px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .wechat-pay-img {
    height: 370px;
    width: 370px;
  }
}
</style>